const ROOT = 'positions' as const
// Detail historically used a singular root; keep it so existing cache invalidation stays valid.
const DETAIL_ROOT = 'position' as const

export const positionsKeys = {
  all: [ROOT] as const,
  list: (
    params: (string | number | boolean | (number | string)[] | undefined)[] = []
  ) => [ROOT, 'list', ...params] as const,
  fuzzySearch: (params?: { search?: string; limit?: number }) =>
    [...positionsKeys.all, 'fuzzySearch', params] as const,
  detail: (positionId?: number) => [DETAIL_ROOT, positionId] as const,
  workerMeetsRequirements: (
    positionId?: number,
    companyId?: number,
    workerId?: number
  ) =>
    [
      ...positionsKeys.all,
      'workerMeetsRequirements',
      positionId,
      companyId,
      workerId,
    ] as const,
}
